<div class="col-12">
    <div class="row"
         [ngStyle]="{
             'background': 'linear-gradient( rgba(19, 49, 66, 0.80), rgba(1, 1, 28, 0.80))'
                 + ', url(/assets/project-images/'+ context.bgImage
                 + ') no-repeat center center',
             'background-size': 'cover'
          }">
        <div class="align-self-start align-self-center">
            <h2 [innerHtml]="context.heading | filterHTML"></h2>
            <p>{{ context.content }}</p>
        </div>
        <div class="align-self-end">
            <img src="/assets/project-images/{{ context.image }}" alt="">
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image-spotlight/image-spotlight.component.html